export const getApril30Info = (): { daysLeft: number; isAfterApril30: boolean } => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const april30 = new Date(currentYear, 3, 30);

  const isAfterApril30 = today >= april30;
  const diffTime = april30.getTime() - today.getTime();
  const daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return {
    daysLeft: isAfterApril30 ? 0 : daysLeft,
    isAfterApril30,
  };
};
